import { FC, useCallback, useEffect, useState } from "react";
import { ListUtil } from "src/framework/commons/ListUtil";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { InputCEP } from "src/framework/components/forms/inputs/InputCEP";
import { InputPhone } from "src/framework/components/forms/inputs/InputPhone";
import api, { STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { cidades$, estados$ } from "src/store/global.store";
import { Cidade } from "../geral/RegioesDataTable/types";
import { Tooltip } from "@mui/material";
import { notifierStore } from "src/framework/store/NotifierStore";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputCPFCNPJ } from "src/framework/components/forms/inputs/InputCPFCNPJ";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";
import { NOME_CLIENTE_MAX_LENGTH } from "./constants";

interface FormClientProperties {
    formState: any;
    onChangeValue: (formState: any) => void
    errorState: string[];
    onChangeError: (errorState: any) => void
}

const CLIENTE_PROPOSTA = "cliente_proposta"
const EMAIL_PROPOSTA = "email_proposta"
const CIDADE_ID = "cidade_id"

const FormClienteAvulso: FC<FormClientProperties> = ({ formState, onChangeValue, errorState, onChangeError }) => {
    const estadoListState = useObservable(estados$);
    const cidadeListState = useObservable(cidades$);

    const [estadoSelecionado, setEstadoSelecionado] = useState<string>("")

    useEffect(()=>{
        if (formState?.estado) {
            setEstadoSelecionado(formState.estado.id)
        }
    }, [formState?.estado])

    const validateEmail = (email: string) => {
        return !!String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    };

    return (
        <>
            <div className="row">
                <div className="X12 M6">
                    <InputText label="Título do orçamento" fullWidth
                        value={formState?.titulo}
                        defaultValue={formState?.titulo}
                        maxLength={100}
                        onChange={(e: any) => {
                            const state = { ...formState }
                            state.titulo = e.target.value
                            onChangeValue(state)
                        }}
                    />
                </div>
                <div className="X12 M6">
                    <InputText label="* Nome do cliente" fullWidth
                        value={formState?.cliente_proposta}
                        error={errorState.includes(CLIENTE_PROPOSTA)}
                        maxLength={NOME_CLIENTE_MAX_LENGTH}
                        defaultValue={formState?.cliente_proposta}
                        onChange={(e: any) => {
                            const state = { ...formState }
                            state.cliente_proposta = e.target.value
                            onChangeValue(state)
                        }}
                        onKeyUp={(e: any) => {
                            if (e.target.value !== "") {
                                const idxError = errorState.findIndex((es) => es === CLIENTE_PROPOSTA)
                                if (idxError > -1) {
                                    errorState.splice(idxError, 1)
                                    onChangeError(errorState)
                                }
                            }
                        }}
                    />
                </div>

                <div className="X12 M6">
                    <InputText label="E-mail" fullWidth
                        value={formState?.email_proposta}
                        error={errorState.includes(EMAIL_PROPOSTA)}
                        helperText={errorState.includes(EMAIL_PROPOSTA) ? "E-mail inválido" : ''}
                        inputProps={{
                            autocomplete: 'off',
                        }}
                        onChange={(e: any) => {
                            const state = { ...formState }
                            state.email_proposta = (String(e.target.value) || '').trim()
                            onChangeValue(state)
                        }}
                        onKeyDown={(e: any) => {
                            const spaceRegex = /\s/g
                            e.target.value = e.target.value.replace(spaceRegex, '')
                        }}
                        onKeyUp={(e: any) => {
                            let _errorState = [...errorState]
                            if (e.target.value !== "") {
                                _errorState = ListUtil.removeItem(_errorState, EMAIL_PROPOSTA)
                                if (ValidateUtil.isValidEmail(e.target.value) && validateEmail(e.target.value)) {
                                    _errorState = ListUtil.removeItem(_errorState, EMAIL_PROPOSTA)
                                } else {
                                    _errorState = ListUtil.addItem(_errorState, EMAIL_PROPOSTA)
                                }
                            }else{
                                _errorState = ListUtil.removeItem(_errorState, EMAIL_PROPOSTA)
                            }
                            onChangeError(_errorState)
                        }}
                    />
                </div>
                <div className="X12 M6">
                    <InputComboBoxList
                        id={`listagem-verticais-estado-cb`}
                        key={`listagem-verticais-estado-cb`}
                        label={"* UF"}
                        disabled={true}
                        textField="nome"
                        valueField="id"
                        options={estadoListState?.data || []}
                        value={formState?.estado || null}
                        autoComplete
                        renderOptions={(option: any) => {
                            return `${option.id} - ${option.nome}`
                        }}
                        renderOptionsLabel={(option: any) => {
                            return `${option.id} - ${option.nome}`
                        }}
                        onChange={(value: any) => {
                            const state = { ...formState };
                            if (value) {
                                state.isTrocaUf = false;
                                state.tarifa_concessionaria_id = state.tarifa_concessionaria_id_original;
                                state.preco_kwh_com_imposto = state.preco_kwh_com_imposto_original;

                                if(value.id !== state?.estado_original?.id){
                                    state.isTrocaUf = true;
                                }

                                state.estado = value;
                                state.cidade = undefined;
                                state.cidade_id = undefined;

                                setEstadoSelecionado(String(value.id))

                            } else {
                                state.estado = null;
                                setEstadoSelecionado('')
                            }
                            onChangeValue(state)
                        }}
                    />
                </div>
            </div>
        </>
    );
}

export { FormClienteAvulso }